import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  standalone: false,
  name: 'planningPackagesPipe'
})
export class PlanningPackagesPipe implements PipeTransform {

  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(packages, enableSuffix: boolean = true, defaultValue?): unknown {
    const count = _.reduce(packages, (sum, p) => {
      return sum + _.get(p, 'count', 0);
    }, 0) || 0;
    
    if (!enableSuffix) {
      return count.toString();
    }
    
    return this.translateService.instant(count === 1 ? 'X_PACKAGE' : 'X_PACKAGES', {sum: count});
  }
}
